import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TrainerAttendanceTab from "./checkedin-notcheckedin/TrainerAttendanceTab";
import CommonFilterStructure from "../common-components/CommonFilterStructure";
import { convertStraight } from "../common-data/Converts";
import { fetchTrainerAttendanceData } from "../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";

const TrainerAttendance = ({ userInfoData, prevFilters }) => {
  const dispatch = useDispatch();
  const { trainerAttendance, trainerAttendanceLoading } = useSelector((state) => state.api);
  const [isPage, setIsPage] = useState(0);
  const initialFilters = { selectedOtherUsers: "" };
  const [allFilters, setAllFilters] = useState(initialFilters);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    user_id: allFilters.selectedOtherUsers?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniTbDatas = {
    allData: null,
    pagination: [],
  };
  const [tbDatas, setTbDatas] = useState(iniTbDatas);

  const onClickReset = () => {
    setAllFilters(initialFilters);
    setFilters(iniFilters);
  };

  function getTrainerAttendance() {
    const { date_from, date_to, ...rest } = prevFilters;
    const pieChartGetApiFilters = {
      ...rest,
      account_type: "trainer",
      date_from: convertStraight(date_from),
      date_to: convertStraight(date_to),
      ...filters,
    };

    dispatch(
      fetchTrainerAttendanceData({
        filters: pieChartGetApiFilters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      user_id: allFilters.selectedOtherUsers?.value || "",
    }));
  }, [allFilters, isPage]);

  useEffect(() => {
    getTrainerAttendance();
  }, [prevFilters, filters]);

  useEffect(() => {
    if (trainerAttendance?.status && trainerAttendance?.data) {
      setTbDatas((prevs) => ({
        ...prevs,
        allData: trainerAttendance.data,
        pagination: trainerAttendance?.pagination || [],
      }));
    } else {
      setTbDatas(iniTbDatas);
    }
  }, [trainerAttendance]);

  return (
    <>
      <CommonFilterStructure
        from={"trainer-checkedin-notcheckedin"}
        decryptedText={userInfoData}
        setFilters={setAllFilters}
        filters={allFilters}
        onClickReset={onClickReset}
        isTrainers={true}
        otherUserLabel={"Trainer"}
      />

      {trainerAttendanceLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <TrainerAttendanceTab
          tbDatas={tbDatas}
          isPage={isPage}
          setIsPage={setIsPage}
        />
      )}
    </>
  );
};

export default TrainerAttendance;
